import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { canActivate } from './shared/helpers/auth.guard';
import { canActivateSignIn } from './shared/helpers/signin.guard';
import { canActivateRoleRedirect } from './shared/helpers/role-redirect.guard';
import { RedirectComponent } from './modules/redirect/redirect.component';
import { CodingQuestionsComponent } from './modules/coding-questions-practice/coding-questions.component';
import { PracticeQuestionsComponent } from './modules/coding-questions-practice/practice-questions/practice-questions.component';
import { ProblemQuestionComponent } from './modules/coding-questions-practice/problem-question/problem-question.component';
import { SubCategoryComponent } from './modules/coding-questions-practice/sub-category/sub-category.component';

const routes: Routes = [
  { path: '', canActivate: [canActivateRoleRedirect], component: RedirectComponent },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/Authentication/authentication.module').then((m) => m.AuthenticationModule),
    canActivate: [canActivateSignIn],
  },
  {
    path: 'job-posting',
    loadChildren: () =>
      import('./modules/job-posting/job-posting.module').then((m) => m.JobPostingModule),
    canActivate: [canActivate],
  },
  {
    path: 'cnd-jobs',
    loadChildren: () =>
      import('./modules/cnd-jobs/cnd-jobs.module').then((m) => m.CndJobsModule),
    canActivate: [canActivate],
  },
  {
    path: 'user-management',
    loadChildren: () =>
      import('./modules/user-management/user-management.module').then(
        (m) => m.UserManagementModule,
      ),
    canActivate: [canActivate],
  },
  {
    path: 'auth-reset-password',
    loadChildren: () =>
      import('./modules/auth-reset-password/auth-reset-password.module').then(
        (m) => m.AuthResetPasswordModule,
      ),
    canActivate: [canActivate],
  },
  {
    path: 'org-management',
    loadChildren: () =>
      import('./modules/org-management/org-management.module').then((m) => m.OrgManagementModule),
    canActivate: [canActivate],
  },
  {
    path: 'contest-management',
    loadChildren: () =>
      import('./modules/contest-management/contest-management.module').then((m) => m.ContestManagementModule),
    canActivate: [canActivate],
  },
  {
    path: 'contest-arena',
    loadChildren: () =>
      import('./modules/contest-arena/contest-arena.module').then((m) => m.ContestArenaModule),
    canActivate: [canActivate],
  },
  {
    path: 'exam',
    loadChildren: () => import('./modules/exam/exam.module').then((m) => m.ExamModule),
    canActivate: [canActivate],
  },
  {
    path: 'hiring',
    loadChildren: () => import('./modules/hiring/hiring.module').then((m) => m.HiringModule),
    canActivate: [canActivate],
  },
  {
    path: 'billings/:mode',
    loadChildren: () => import('./modules/billings/billings.module').then((m) => m.BillingsModule),
    canActivate: [canActivate],
  },
  {
    path: 'candidate-assesment',
    loadChildren: () =>
      import('./modules/conduct-exam-portal/conduct-exam-portal.module').then(
        (m) => m.ConductExamPortalModule,
      ),
    canActivate: [canActivate],
  },
  {
    path: 'exam-portal',
    loadChildren: () =>
      import('./modules/exam-portal/exam-portal.module').then((m) => m.ExamPortalModule),
    canActivate: [canActivate],
  },
  // app-routing.module.ts
{
  path: 'game1',
  loadChildren: () =>
    import('./modules/game-engine/game-1/game-1.module').then((m) => m.Game1Module),
  canActivate: [canActivate],
},
{
  path: 'game2',
  loadChildren: () =>
    import('./modules/game-engine/game-2/game-2.module').then((m) => m.Game2Module),
  canActivate: [canActivate],
},
{
  path: 'game3',
  loadChildren: () =>
    import('./modules/game-engine/game-3/game-3.module').then((m) => m.Game3Module),
  canActivate: [canActivate],
},
  
  {
    path: 'admin-dashboard',
    loadChildren: () =>
      import('./modules/admin-dashboard/admin-dashboard.module').then(
        (m) => m.AdminDashboardModule,
      ),
    canActivate: [canActivate],
  },
  {
    path: 'candidate-dashboard',
    loadChildren: () =>
      import('./modules/candidate-dashboard/candidate-dashboard.module').then(
        (m) => m.CandidateDashboardModule,
      ),
    canActivate: [canActivate],
  },
  {
    path: 'employee-dashboard',
    loadChildren: () =>
      import('./modules/employee-dashboard/employee-dashboard.module').then(
        (m) => m.EmployeeDashboardModule,
      ),
    canActivate: [canActivate],
  },
  {
    path: 'recruiter-dashboard',
    loadChildren: () =>
      import('./modules/recruiter-dashboard/recruiter-dashboard.module').then(
        (m) => m.RecruiterDashboardModule,
      ),
    canActivate: [canActivate],
  },
  {
    path: 'hr-dashboard',
    loadChildren: () =>
      import('./modules/hr-dashboard/hr-dashboard.module').then(
        (m) => m.HrDashboardModule,
      ),
    canActivate: [canActivate],
  },
  {
    path: 'tl-dashboard',
    loadChildren: () =>
      import('./modules/tl-dashboard/tl-dashboard.module').then(
        (m) => m.TlDashboardModule,
      ),
    canActivate: [canActivate],
  },
  {
    path: 'reporting-manager-dashboard',
    loadChildren: () =>
      import(
        './modules/reporting-manager-dashboard/reporting-manager-dashboard.module'
      ).then((m) => m.ReportingManagerDashboardModule),
    canActivate: [canActivate],
  },
  {
    path: 'system-admin-dashboard',
    loadChildren: () =>
      import(
        './modules/system-admin-dashboard/system-admin-dashboard.module'
      ).then((m) => m.SystemAdminDashboardModule),
    canActivate: [canActivate],
  },
  {
    path: 'ai-interview',
    loadChildren: () =>
      import('./modules/ai-interview/ai-interview.module').then((m) => m.AiInterviewModule),
    canActivate: [canActivate],
  },
  {
    path: 'book-slot',
    loadChildren: () =>
      import('./modules/book-slots/book-slots.module').then((m) => m.BookSlotsModule),
    canActivate: [canActivate],
  },
  {
    path: 'acceptorreject-offer',
    loadChildren: () =>
      import('./modules/accept-offer/accept-offer.module').then((m) => m.AcceptOfferModule),
    canActivate: [canActivate],
  },
  {
    path: 'candidate-profile',
    loadChildren: () =>
      import('./modules/candidate-profile/candidate-profile.module').then(
        (m) => m.CandidateProfileModule,
      ),canActivate: [canActivate]
  },
  {
    path: 'resume-builder',
    loadChildren: () =>
      import('./modules/resume-builder/resume-builder.module').then((m) => m.ResumeBuilderModule),canActivate: [canActivate]
  },

 {
    path: 'practice',

    loadChildren: () =>
      import(
        './modules/coding-questions-practice/coding-question-routing.module'
      ).then(
        m => m.CodingQuestionsRoutingModule
      ),canActivate: [canActivate]
  },

  {
    path: 'leaderboard',
    loadChildren: () =>
      import('./modules/leaderboard/leaderboard.module').then((m) => m.LeaderboardModule),canActivate: [canActivate]
  },

  {
    path: 'daily-challenge',
    loadChildren: () =>
      import('./modules/prob-of-the-day/prob-of-the-day.module').then((m) => m.ProbOfTheDayModule),canActivate: [canActivate]
  },

  {
    path: 'notifications',
    loadChildren: () =>
      import('./modules/notifications/notifications.module').then((m) => m.NotificationsModule),canActivate: [canActivate]
  },

  {
    path: 'employee-profile',
    loadChildren: () =>
      import('./modules/org-profile/org-profile.module').then((m) => m.OrgProfileModule),
    canActivate: [canActivate],
  },

  {
    path: 'challenge-packs',
    loadChildren: () =>
      import('./modules/challenge-packs/challenge-packs.module').then((m) => m.ChallengePacksModule),canActivate: [canActivate]
  },

  {
    path: 'lms',
    loadChildren: () =>
      import('./modules/LMS/lms.module').then((m) => m.LmsModule),
    canActivate: [canActivate],
  },

  {
    // System Admin only (guarded again inside ConfiguratorModule).
    path: 'configurator',
    loadChildren: () =>
      import('./modules/configurator/configurator.module').then((m) => m.ConfiguratorModule),
    canActivate: [canActivate],
  },

  { path: '**', redirectTo: 'auth', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
